<template>
    <div class="container">
        <el-page-header @back="$router.back()" content="添加记录"></el-page-header>
        <div class="content" v-if="pageShow">
            <el-form :model="form" ref="form" :rules="rules" size="mini" class="form" label-width="100px">
                <el-row type="flex">
                    <div>
                        <el-form-item label="赛事组别：" prop="leagueGroupId">
                            <el-select placeholder="请选择赛事组别" v-model="form.leagueGroupId" @change="leagueGroupChange">
                                <el-option v-for="(item,index) in leagueGroupList" :value="item.LeagueGroupId" :label="`${item.LeagueName} ${item.LeagueGroupName}`" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="轮次：" prop="roundsNo">
                            <el-select placeholder="请选择轮次" v-model="form.roundsNo" :disabled="!form.leagueGroupId" @change="roundsNoChange">
                                <template v-if="groupInfo">
                                    <el-option v-for="n in groupInfo.MatchRounds" :value="n" :label="`第${n}轮`" :key="n"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="桌号：" prop="tableNo">
                            <el-select placeholder="请选择桌号" v-model="form.tableNo" :disabled="!form.roundsNo" @change="tableNoChange">
                                <template v-if="form.roundsNo">
                                    <el-option v-for="n in tableNos" :value="n" :label="`${n}号桌`" :key="n"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="运动员姓名：" required label-width="160px">
                            <el-row type="flex">
                                <div>
                                    <el-form-item label="东：" prop="eastName" label-width="50px" style="margin: 0;">
                                        <el-input type="text" v-model="form.eastName" :maxlength="10" style="width: 100px;"></el-input>
                                    </el-form-item>
                                    <el-row type="flex" justify="center">
                                        <el-button type="primary" icon="el-icon-sort" circle @click="exchange('ew')" style="margin: 10px 0;"></el-button>
                                    </el-row>
                                    <el-form-item label="西：" prop="westName" label-width="50px" style="margin: 0;">
                                        <el-input type="text" v-model="form.westName" :maxlength="10" style="width: 100px;"></el-input>
                                    </el-form-item>
                                </div>
                                <div style="flex: none;width: 60px;">
                                    <el-row type="flex" justify="center" align="middle" style="height: 100%;">
                                        <el-button type="success" icon="el-icon-sort" circle @click="exchange()" style="transform: rotate(90deg);"></el-button>
                                    </el-row>
                                </div>
                                <div>
                                    <el-form-item label="南：" prop="southName" label-width="50px" style="margin: 0;">
                                        <el-input type="text" v-model="form.southName" :maxlength="10" style="width: 100px;"></el-input>
                                    </el-form-item>
                                    <el-row type="flex" justify="center">
                                        <el-button type="primary" icon="el-icon-sort" circle @click="exchange('ns')" style="margin: 10px 0;"></el-button>
                                    </el-row>
                                    <el-form-item label="北：" prop="northName" label-width="50px" style="margin: 0;">
                                        <el-input type="text" v-model="form.northName" :maxlength="10" style="width: 100px;"></el-input>
                                    </el-form-item>
                                </div>
                            </el-row>
                        </el-form-item>
                    </div>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="视频日期：" prop="date">
                            <el-date-picker
                                v-model="form.date"
                                type="date"
                                placeholder="请选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="视频URL：" prop="videoUrl">
                            <el-input v-model="form.videoUrl" style="max-width: 700px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="封面URL：" prop="coverUrl">
                            <el-input v-model="form.coverUrl" style="max-width: 700px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="预览：">
                            <div class="preview_video" v-if="form.coverUrl" @click="preview()">
                                <img :src="form.coverUrl">
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-button type="primary" style="margin-left: 100px" @click="save()"> 保存 </el-button>
                </el-row>
            </el-form>
        </div>
        <PreviewVideo :visible.sync="previewVideoVisible" :data="previewVideoData"></PreviewVideo>
    </div>
</template>

<script>
import utils from '@/utils';
import PreviewVideo from './components/PreviewVideo.vue';
export default {
    components: {
        PreviewVideo
    },
    data(){
        return {
            pageShow: false,
            leagueGroupList: [],
            tableNos: [],
            form: {
                leagueGroupId: undefined,
                roundsNo: undefined,
                tableNo: undefined,
                eastName: '',
                westName: '',
                southName: '',
                northName: '',
                date: '',
                videoUrl: '',
                coverUrl: ''
            },
            previewVideoData: null,
            previewVideoVisible: false
        }
    },
    created() {
        this.form.date = utils.dateFormat(Date.now(), 'yyyy-MM-dd');
        this.GetLeagueGroupListByEndDate();
    },
    computed: {
        rules(){
            let getNameRule = (label)=>{
                return [
                    {required: true, validator: (_, value, callback)=>{
                        if(!value){
                            callback(new Error(`请输入${label}姓名`));
                        }else if(value.length > 10){
                            callback(new Error('长度超出限制，最大10个字符'));
                        }else{
                            callback();
                        }
                    }
                }]
            }
            return {
                leagueGroupId: [
                    {required: true, message: '请选择赛事组别'}
                ],
                roundsNo: [
                    {required: true, validator: (_, value, callback)=>{
                        if(!value){
                            callback(new Error('请选择轮次'));
                        }else{
                            callback();
                        }
                    }
                }],
                tableNo: [
                    {required: true, validator: (_, value, callback)=>{
                        if(!value){
                            callback(new Error('请选择桌号'));
                        }else{
                            callback();
                        }
                    }
                }],
                eastName: getNameRule('东家'),
                westName: getNameRule('西家'),
                southName: getNameRule('南家'),
                northName: getNameRule('北家'),
                videoUrl: [
                    {required: true, message: '请输入视频URL'}
                ],
                coverUrl: [
                    {required: true, message: '请输入封面URL'}
                ]
            }
        },
        groupInfo(){
            return this.leagueGroupList.find(item=>item.LeagueGroupId == this.form.leagueGroupId);
        }
    },
    methods: {
        GetLeagueGroupListByEndDate(){
            let EndTime = Date.now() + (400 * 24 * 60 * 60 * 1000),
                BeginTime = Date.now() - (400 * 24 * 60 * 60 * 1000);
            this.$api.GetLeagueGroupListByEndDate({
                "BeginTime": utils.dateFormat(BeginTime, 'yyyy-MM-ddT00:00:00'),
                "EndTime": utils.dateFormat(EndTime, 'yyyy-MM-ddT23:59:59')
            }).then(data=>{
                if(data.Code == 0){
                    this.pageShow = true;
                    this.leagueGroupList = data.GroupList || [];
                }
            })
        },
        GetMatchGroupRoundTableNoList(){
            this.$api.GetMatchGroupRoundTableNoList({
                "LeagueGroupId": this.groupInfo.LeagueGroupId,
                "RoundsNo": this.form.roundsNo
            }).then(data=>{
                if(data.Code == 0){
                    this.tableNos = data.TableNos || [];
                }
            })
        },
        GetMatchTablePlayerNames(){
            this.$api.GetMatchTablePlayerNames({
                "LeagueGroupId": this.groupInfo.LeagueGroupId,
                "RoundsNo": this.form.roundsNo,
                "TableNo": this.form.tableNo
            }).then(data=>{
                if(data.Code == 0){
                    if(!data.PlayerNames) return;
                    let {
                        PlayerEastName,
                        PlayerWestName,
                        PlayerSouthName,
                        PlayerNorthName
                    } = data.PlayerNames;
                    this.form = {
                        ...this.form,
                        eastName: PlayerEastName || '',
                        westName: PlayerWestName || '',
                        southName: PlayerSouthName || '',
                        northName: PlayerNorthName || ''
                    }
                }
            })
        },
        leagueGroupChange(){
            this.$set(this.form, 'roundsNo', undefined);
            this.$set(this.form, 'tableNo', undefined);
        },
        roundsNoChange(){
            this.$set(this.form, 'tableNo', undefined);
            if(!this.form.roundsNo) return;

            this.GetMatchGroupRoundTableNoList();
        },
        tableNoChange(){
            if(!this.form.tableNo) return;

            this.GetMatchTablePlayerNames();
        },
        exchange(type){
            let {
                eastName,
                westName,
                southName,
                northName
            } = this.form;
            if(type == 'ew'){
                this.$set(this.form, 'eastName', westName);
                this.$set(this.form, 'westName', eastName);
            }else if(type == 'ns'){
                this.$set(this.form, 'southName', northName);
                this.$set(this.form, 'northName', southName);
            }else{
                this.$set(this.form, 'eastName', southName);
                this.$set(this.form, 'westName', northName);
                this.$set(this.form, 'southName', westName);
                this.$set(this.form, 'northName', eastName);
            }
        },
        preview(){
            this.previewVideoData = {
                src: this.form.videoUrl,
                poster: this.form.coverUrl
            };
            this.previewVideoVisible = true;
        },
        save(){
            this.$refs.form.validate(valid=>{
                if(valid){
                    let loading = this.$loading({
                        text: '保存中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.8)'
                    })
                    let form = this.form;
                    this.$api.SaveReplayVideo({
                        "ReplayVideo": {
                            "ReplayVideoId": 0,
                            "LeagueId": this.groupInfo.LeagueId,
                            "LeagueName": this.groupInfo.LeagueName,
                            "LeagueGroupId": this.groupInfo.LeagueGroupId,
                            "LeagueGroupName": this.groupInfo.LeagueGroupName,
                            "RoundsNo": form.roundsNo,
                            "TableNo": form.tableNo,
                            "PlayerNames": {
                                "PlayerEastName": form.eastName,
                                "PlayerWestName": form.westName,
                                "PlayerSouthName": form.southName,
                                "PlayerNorthName": form.northName
                            },
                            "VideoTime": utils.dateFormat(form.date, 'yyyy-MM-dd'),
                            "VideoUrl": form.videoUrl,
                            "CoverUrl": form.coverUrl
                        }
                    }).then(data=>{
                        loading.close();
                        if(data.Code == 0){
                            this.$alert('添加成功', '提示', {
                                confirmButtonText: '返回列表',
                                showClose: false
                            }).then(() => {
                                this.$router.push('/guandan/deckVideoList');
                            })
                        }
                    }).catch(()=>loading.close());
                }else{
                    this.$message.error('填写信息有误，请查看！');
                }
            })
        }
    }
}
</script>

<style  scoped>
    .preview_video{
        display: inline-block;
        position: relative;
        cursor: pointer;
    }
    .preview_video::after{
        content: '';
        width: 58px;
        height: 58px;
        background: url('~@/assets/imgs/video_play.png') no-repeat center / 100%;
        position: absolute;
        top: calc(50% - 29px);
        left: calc(50% - 29px);
    }
    .preview_video img{
        width: 300px;
        height: 169px;
        border-radius: 10px;
        object-fit: cover;
    }
</style>